export function getPriorityDropdowns() {
  return [
    { text: "Extremely High Priority", key: 5, value: 5 },
    { text: "High Priority", key: 4, value: 4 },
    { text: "Medium Priority", key: 3, value: 3 },
    { text: "Low Priority", key: 2, value: 2 },
    { text: "Extremely Low Priority", key: 1, value: 1 },
  ];
}

export function convertPriority(priority: number): string {
  const priorities = [
    "Extremely Low Priority",
    "Low Priority",
    "Medium Priority",
    "High Priority",
    "Extremely High Priority",
  ];
  return priorities[priority - 1];
}
